import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, shape, func } from "prop-types";
import classNames from "classnames";
import GridTable from "pages/_components/GridTable/GridTable";

import PaymentDueListItem from "./PaymentDueListItem";

const PaymentDueList = ({ dataToList, isDesktop, onChange, isConfirmPage }) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [totalAmountSelected, setTotalAmountSelected] = useState(0);

    useEffect(() => {
        setSelectedItems([]);
        setTotalAmountSelected(0);
    }, [dataToList]);

    useEffect(() => {
        if (onChange) {
            onChange(selectedItems, totalAmountSelected);
        }
    }, [onChange, totalAmountSelected]);

    const handleSelect = (id, value) => {
        if (value) {
            const idx = dataToList.findIndex((v) => v.id === id);
            if (idx !== -1) {
                const services = selectedItems;
                services.push(dataToList[idx]);
                setSelectedItems(services);
                const amount = totalAmountSelected + dataToList[idx].amount;
                setTotalAmountSelected(amount);
            }
        } else {
            const idx = selectedItems.findIndex((v) => v.id === id);
            if (idx !== -1) {
                const amount = totalAmountSelected - selectedItems[idx].amount;
                setTotalAmountSelected(amount);
                const services = selectedItems;
                services.splice(idx, 1);
                setSelectedItems(services);
            }
        }
    };

    return (
        <GridTable className={classNames("payment-due-list")}>
            {dataToList.map((rowData) => (
                <PaymentDueListItem
                    isDesktop={isDesktop}
                    data={rowData}
                    onChange={handleSelect}
                    isConfirmPage={isConfirmPage}
                />
            ))}
        </GridTable>
    );
};

PaymentDueList.propTypes = {
    dataToList: arrayOf(shape({})).isRequired,
    isDesktop: bool.isRequired,
    onChange: func.isRequired,
    isConfirmPage: bool,
};

PaymentDueList.defaultProps = {
    isConfirmPage: false,
};

export default connect()(PaymentDueList);
